// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
  color: '';
}
`, "",{"version":3,"sources":["webpack://./src/components/collapsable-section/collapsible-section.css"],"names":[],"mappings":"AAAA;EACE,SAAS;AACX","sourcesContent":[".MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {\n  color: '';\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
